import React from "react";
import { Link } from "react-router-dom";

export default function verifyEmail() {
  return (
    <>
      <div className="flex items-center justify-center py-24">
        <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
          <h2 className="kn-h2 mb-4">E-Mail Bestätigung</h2>
          <p className="kn-body mb-6">
            Wir haben Ihnen eine E-Mail zur Bestätigung Ihres Kontos gesendet.
            Bitte überprüfen Sie Ihren Posteingang und folgen Sie den
            Anweisungen in der E-Mail, um Ihre Registrierung abzuschließen.
          </p>

          <Link to="/login">
            <button className="kn-btn-primary w-full mt-4 self-center">
              Zurück zum Login
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}
